module.exports = __webpack_public_path__ + "static/media/PromoCodeIcon.d6320fc0.svg";